<div class="ubi-modal">

  <div class="ubi-header">
    <ion-icon name="location" class="ubi-icon"></ion-icon>
    <h2 class="ubi-titulo">¿Dónde te encuentras?</h2>
    <p class="ubi-sub">Selecciona tu municipio para continuar</p>
  </div>

  <!-- Buscador -->
  <div class="ubi-buscador">
    <ion-icon name="search-outline"></ion-icon>
    <input type="text" [value]="busqueda" (input)="buscar($event)"
           placeholder="Escribe tu municipio..." autocomplete="off">
  </div>

  <!-- Resultados -->
  <div class="ubi-resultados" *ngIf="resultados.length > 0">
    <div class="ubi-item" *ngFor="let item of resultados" (click)="seleccionar(item)">
      <div class="ubi-item-info">
        <span class="ubi-muni">{{ item.municipio }}</span>
        <span class="ubi-depto">{{ item.departamento }}</span>
      </div>
      <ion-icon name="chevron-forward-outline"></ion-icon>
    </div>
  </div>

  <!-- Mensaje cuando no hay resultados -->
  <p class="ubi-vacio" *ngIf="busqueda.length >= 2 && resultados.length === 0 && !seleccion">
    No se encontró "{{ busqueda }}"
  </p>

  <!-- Selección confirmada -->
  <div class="ubi-seleccion" *ngIf="seleccion">
    <ion-icon name="checkmark-circle" class="ubi-check"></ion-icon>
    <div>
      <span class="ubi-sel-muni">{{ seleccion.municipio }}</span>
      <span class="ubi-sel-depto">{{ seleccion.departamento }}</span>
    </div>
  </div>

  <!-- Guardar -->
  <button class="ubi-btn" [disabled]="!seleccion || guardando" (click)="guardar()">
    <ion-spinner *ngIf="guardando" name="crescent"></ion-spinner>
    <span *ngIf="!guardando">Confirmar ubicación</span>
  </button>

</div>